export default __webpack_public_path__ + "static/media/Yanis.e41d31ad.png";